import React, { useState, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import { toast } from 'react-toastify';

const VoiceRecorder = ({ onRecordingComplete, onCancel }) => {
    const [isRecording, setIsRecording] = useState(false);
    const [audioURL, setAudioURL] = useState('');
    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);

    const startRecording = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            
            // Detect supported MIME types
            const types = [
                'audio/webm;codecs=opus',
                'audio/webm',
                'audio/ogg;codecs=opus',
                'audio/mp4',
                'audio/wav',
            ];
            const supportedType = types.find(type => MediaRecorder.isTypeSupported(type)) || '';
            
            mediaRecorderRef.current = new MediaRecorder(stream, supportedType ? { mimeType: supportedType } : {});
            audioChunksRef.current = [];

            mediaRecorderRef.current.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    audioChunksRef.current.push(event.data);
                }
            };

            mediaRecorderRef.current.onstop = () => {
                const mimeType = mediaRecorderRef.current.mimeType || 'audio/wav';
                const audioBlob = new Blob(audioChunksRef.current, { type: mimeType });
                const url = URL.createObjectURL(audioBlob);
                setAudioURL(url);
                onRecordingComplete(audioBlob, url);
                
                // Stop all tracks to release the microphone
                stream.getTracks().forEach(track => track.stop());
            };

            mediaRecorderRef.current.start();
            setIsRecording(true);
        } catch (err) {
            console.error('Error accessing microphone:', err);
            toast.error('Could not access microphone. Please check permissions.');
        }
    };

    const stopRecording = () => {
        if (mediaRecorderRef.current && isRecording) {
            mediaRecorderRef.current.stop();
            setIsRecording(false);
        }
    };

    return (
        <div className="voice-recorder-container p-2 bg-light rounded border mb-2">
            <div className="d-flex align-items-center justify-content-between">
                <div>
                    {!isRecording ? (
                        <Button variant="outline-danger" size="sm" onClick={startRecording}>
                            <i className="fas fa-microphone me-2"></i> Record
                        </Button>
                    ) : (
                        <Button variant="danger" size="sm" onClick={stopRecording}>
                            <i className="fas fa-stop me-2"></i> Stop ({'Recording...'})
                        </Button>
                    )}
                </div>
                {audioURL && (
                    <div className="d-flex align-items-center gap-2">
                        <audio src={audioURL} controls style={{ height: '45px' }} />
                    </div>
                )}
                <Button variant="link" size="sm" className="text-muted" onClick={onCancel}>
                    Cancel
                </Button>
            </div>
        </div>
    );
};

export default VoiceRecorder;
